import { Nullable, Scene, TransformNode } from "@babylonjs/core";
import { IGLTFLoaderExtension } from "@babylonjs/loaders";
import { GLTFLoader, INode } from "@babylonjs/loaders/glTF/2.0";
import { ModelLoader } from "./modelLoader";
import { JsonDB } from "./JsonDB";


export class IBCADDY_external_model implements IGLTFLoaderExtension {
    name: string;
    enabled: boolean;
    order?: number;
    _loader: GLTFLoader;
    _scene: Scene;
    _modelloader: ModelLoader;
    _containers: string[] = [];
    _jsonDB: JsonDB;

    constructor(loader: GLTFLoader, scene: Scene, modelloader: ModelLoader, json: JsonDB) {
        this.name = "IBCADDY_external_model";
        this.enabled = true;
        this._loader = loader;
        this._scene = scene;
        this._modelloader = modelloader;
        this._jsonDB = json;
    }

    dispose() {
    }

    public loadNodeAsync(context: string, node: INode, assign: (babylonTransformNode: TransformNode) => void): Nullable<Promise<TransformNode>> {

        return GLTFLoader.LoadExtensionAsync(context, node, this.name, (extensionContext: string, extension) => {
            const ext = extension as any;
            this._loader._allMaterialsDirtyRequired = true;

            return this._loader.loadNodeAsync(context, node, (nodeTransform) => {
                if (!ext.load) {
                    return nodeTransform;
                }

                const group = this._jsonDB.Groups.get(ext.uri);
                if (group)
                    this._modelloader.CurrentGroups.set(ext.uri, group);

                this._modelloader.IBCADDY_external_model.push(this);
                if (!this._modelloader.ShowLoading) {
                    this._modelloader.ShowLoading = true;
                }

                //console.log(this._modelloader.fetchFileUrl(ext.uri))
                return this._modelloader.fetchFileUrl(ext.uri).then((file) => {
                    
                    console.log("Loading model:", ext.uri, "->", file)
                    
                    return this._modelloader.LoadAsyncModelNoClear(file).then((result) => {
                        this._modelloader.AllComponentsFilePath.push(this.getFilenameFromURI(file))
                        const mat = nodeTransform.getWorldMatrix();
                        mat.decomposeToTransformNode(result);
                        assign(nodeTransform);

                        console.log("file loaded")

                        // Debugging logs
                        this._modelloader.IBCADDY_external_model.pop();

                        if (this._modelloader.IBCADDY_external_model.length === 0) {
                            console.log("Loading default materials...");
                            const materialPromises = [];
                            for (const [key, value] of this._jsonDB.DefaultMaterialTag) {
                                materialPromises.push(
                                    this._modelloader.fetchFileUrl(value as string).then((result) => {
                                        console.log("Loading material:", value, "->", result);
                                        this._modelloader.LoadMaterial(result, key);
                                    }).catch(error => {
                                        console.error("Error loading material:", error);
                                    })
                                );
                            }
                            return Promise.all(materialPromises).then(() => {
                                this._modelloader.ShowLoading = false;
                            });
                        } else {
                            return Promise.resolve();
                        }
                    }).catch(error => {
                        console.error("Error loading model:", error);
                        this._modelloader.ShowLoading = false;
                    });
                }).catch(error => {
                    console.error("Error fetching file URL:", error);
                    this._modelloader.ShowLoading = false;
                });
            });
        });
    }
    getFilenameFromURI(uri: string) {
        // Replace backslashes with forward slashes
        const normalizedUri = uri.replace(/\\/g, '/');
        const url = new URL(normalizedUri);
        const filename = url.pathname.split('/').pop();
        return decodeURIComponent(filename);
    }
}



// Register the extension
